export const MAX_VISIBLE_SELECTED_WORK_ITEMS = 5;
